var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock } from "vue";
import { ElDialog } from "element-plus";
import 'element-plus/es/components/dialog/style/css'

import { ref, onMounted, watch, nextTick, useAttrs } from "vue";
import { sleep } from "@/js/lib/helper/sleep";
import IButton from "./IButton.vue";
export default /* @__PURE__ */ _defineComponent({
  __name: "IModal",
  props: {
    modelValue: { type: Boolean, default: true },
    width: { default: "500px" },
    textCancel: { default: "\u30AD\u30E3\u30F3\u30BB\u30EB" },
    textOk: { default: "OK" },
    withCloseButton: { type: Boolean, default: true },
    withActionButton: { type: Boolean },
    withCancelButton: { type: Boolean, default: true },
    closeOnCancel: { type: Boolean, default: true },
    closeOnOk: { type: Boolean, default: true },
    fadeOut: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["update:modelValue", "open", "close", "cancel", "ok"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const attrs = useAttrs();
    const buttonOk = ref();
    const isShow = ref(false);
    const modalClose = () => {
      isShow.value = false;
    };
    const onCancel = () => {
      if (props.closeOnCancel) {
        isShow.value = false;
      }
      emit("cancel");
    };
    const onOk = () => {
      emit("ok");
      if (props.closeOnOk) {
        isShow.value = false;
      }
    };
    onMounted(() => __async(this, null, function* () {
      isShow.value = props.modelValue;
      if (props.withActionButton) {
        nextTick(() => {
          if (buttonOk.value) {
            buttonOk.value.focus();
          }
        });
      }
      if (props.fadeOut) {
        yield sleep(1200);
        isShow.value = false;
      }
    }));
    watch(
      () => props.modelValue,
      () => {
        isShow.value = props.modelValue;
      }
    );
    watch(isShow, () => {
      if (isShow.value) {
        emit("open");
      } else {
        emit("close");
        emit("update:modelValue", false);
      }
    });
    __expose({
      modalClose
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(ElDialog), _mergeProps({
        modelValue: isShow.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isShow.value = $event),
        class: [_ctx.$style.dialog, _ctx.isLoading && _ctx.$style.loading],
        width: _ctx.width,
        "append-to-body": true,
        "show-close": _ctx.withCloseButton
      }, _unref(attrs)), {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.withActionButton && _ctx.$style.withActionButton])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.content)
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 2),
            _cache[2] || (_cache[2] = _createTextVNode()),
            _ctx.withActionButton ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _ctx.withCancelButton ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([_ctx.$style.buttonArea, _ctx.$style.hasCancel])
              }, [
                _createVNode(IButton, { onClick: onCancel }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.textCancel), 1)
                  ]),
                  _: 1
                }),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createVNode(IButton, {
                  ref_key: "buttonOk",
                  ref: buttonOk,
                  type: "primary",
                  onClick: onOk
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.textOk), 1)
                  ]),
                  _: 1
                }, 512)
              ], 2)) : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.$style.buttonArea)
              }, [
                _createVNode(IButton, {
                  ref_key: "buttonOk",
                  ref: buttonOk,
                  type: "primary",
                  onClick: onOk
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.textOk), 1)
                  ]),
                  _: 1
                }, 512)
              ], 2))
            ], 64)) : _createCommentVNode("", true),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _ctx.$slots.footer ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(_ctx.$style.footer)
            }, [
              _renderSlot(_ctx.$slots, "footer")
            ], 2)) : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 3
      }, 16, ["modelValue", "class", "width", "show-close"]);
    };
  }
});
